import React from 'react';
import uniqWith from 'lodash/uniqWith';
import pick from 'lodash/pick';

// Types
import { Type, SubType, TypeNames } from 'Shared/types/Capture.types';

// Utils
import { getSurfaceTypeName } from '../SurfaceAI.utils';

// Components
import FilterListItem from './FilterListItem';
import SurfaceItemLogo from '../SurfaceRowComponents/SurfaceItemLogo';

// Styles
import './IntegrationsFilterList.scss';

type IntegrationsFilterListItemProps = {
  type: { type: Type; subtype: SubType };
  selectedTypes: Array<TypeNames>;
  updateFilters: Function;
};

const IntegrationsFilterListItem = ({ type, selectedTypes = [], updateFilters }: IntegrationsFilterListItemProps) => {
  const value: TypeNames = getSurfaceTypeName({ type: type.type, subtype: type.subtype });
  const isChecked = selectedTypes.includes(value);

  const handleChange = (checked: boolean) => {
    if (updateFilters) {
      if (checked) updateFilters({ typeName: [...selectedTypes, value] });
      else updateFilters({ typeName: selectedTypes.filter(type => type !== value) });
    }
  };

  return (
    <FilterListItem id={value} label={value} isChecked={isChecked} onChange={handleChange}>
      <div className="IntegrationsFilterList__item">
        <div className="IntegrationsFilterList__item__logo">
          <SurfaceItemLogo surfaceItem={type} />
        </div>
        {value}
      </div>
    </FilterListItem>
  );
};

type Props = {
  surfaceData;
  selectedTypes: Array<TypeNames>;
  updateFilters: Function;
};
const IntegrationsFilterList = ({ surfaceData, selectedTypes = [], updateFilters }: Props) => {
  if (!surfaceData) return null;

  const uniqueTypes = uniqWith(surfaceData, (A, B) => A.type === B.type && A.subtype === B.subtype).map(item =>
    pick(item, ['type', 'subtype'])
  );

  return (
    <div>
      {uniqueTypes.map(type => (
        <IntegrationsFilterListItem
          key={`${type.type}-${type.subtype}`}
          type={type}
          selectedTypes={selectedTypes}
          updateFilters={updateFilters}
        />
      ))}
    </div>
  );
};

export default IntegrationsFilterList;
